module.exports = __webpack_public_path__ + "media/images/riders/small/ADELHEID_MORATH-62728dc9ef567cae3a2cdc38c72c2b55.png";